<template>
    <div class="wrap">
        <Row :gutter="16">
            <i-col :md="16">
                <v-friend-link></v-friend-link>
            </i-col>
            <i-col :md="8">
                <div>
                    <div>
                        微信公众号
                    </div>
                    <img class="wxgzh" :src="require('@/assets/gzh.jpg')">
                </div>
            </i-col>
        </Row>
    </div>
</template>

<script>
    import VFriendLink from "./FriendLink";
    export default {
        name: "v-bar-link",
        components: {VFriendLink}
    }
</script>

<style scoped>
    .wrap {
        max-width: 1000px;
        margin: 16px auto;
    }

    .wxgzh{
        width: 100px;
        height: 100px;
    }
</style>